import { WhiteBox, FoodsIllustrations, FoodsIcon } from "@foodpilot/foods";
import { Box, Button, Stack, Typography, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DIAGNOSTIC_COLOR_INDEX } from ".";
import { URLHandler } from "src/services/URLHandler";
import { Link } from "react-router";

type Props = {
    companyId: number;
    ssqId: number | string | undefined;
    questionnaireName: string | undefined;
};
export const EmptyStrategy = (props: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const { companyId, ssqId, questionnaireName } = props;

    const datavizColors = theme.custom.dataviz.colorsWithExtra[DIAGNOSTIC_COLOR_INDEX];

    return (
        <WhiteBox padding={theme.spacing(3)}>
            <Stack gap={theme.spacing(4)}>
                <Stack gap={theme.spacing(2)} justifyContent={"center"} alignItems={"start"}>
                    <FoodsIllustrations
                        illustration="trajectoryActions"
                        variant={`dataviz-${DIAGNOSTIC_COLOR_INDEX}`}
                    />
                    {questionnaireName !== undefined ?
                        <Typography variant="h3">
                            {t("strategy.welcome.with_name", `Now define your action plan for {{questionnaireName}}!`, {
                                questionnaireName,
                            })}
                        </Typography>
                    :   <Typography variant="h3">{t("strategy.welcome", `Now define your action plan!`)}</Typography>}
                    <Typography variant="body">{t("strategy.welcome.description", " ")}</Typography>
                </Stack>
                <Box>
                    {ssqId !== undefined && (
                        <Link to={URLHandler.company.actions.noActionPlan(companyId, Number(ssqId))}>
                            <Button
                                variant="primary"
                                endIcon={<FoodsIcon size={2} icon="arrowRight" />}
                                sx={{
                                    background: datavizColors.main,
                                    ":hover": {
                                        background: datavizColors.variant[700],
                                    },
                                }}
                            >
                                {t("diagnostic.start_action_plan", `Define my action plan `)}
                            </Button>
                        </Link>
                    )}
                </Box>
            </Stack>
        </WhiteBox>
    );
};
